module.exports = __webpack_public_path__ + "static/media/empty_add_content.54384470.svg";